import React, { useRef, useEffect, cloneElement, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import TYPE from "../../../../constant/TYPE";
import { setInputTypeAction } from "../../../../redux/answeringQuestions/answeringQuestions";
import {
  setNotepadAction,
  setRecognizeRangeAction,
  clearNotepadAction,
  setIsOverStrokeAction,
  setIsOverRemoveStrokeAction
} from "../../../../redux/answeringQuestions/notepad";
import { setAnswerEditorAction, recognizeNotesAction } from "../../../../redux/answeringQuestions/answerEditor";

const NoteTaker = ( props ) => {

  const touchDelayTimer = useRef( 0 );
  const strokeDelayTimer = useRef(0);

  const answeringQuestions = useSelector( state => state.answeringQuestions );
  const notepad = useSelector( state => state.notepad );

  const dispatch = useDispatch();
  const setInputType = payload => { dispatch( setInputTypeAction( payload ) ) };
  const setNotepad = payload => { dispatch( setNotepadAction( payload ) ) };
  const setRecognizeRange = payload => { dispatch( setRecognizeRangeAction( payload ) ) };
  const clearNotepad = () => { dispatch( clearNotepadAction() ) };
  const setAnswerEditor = payload => { dispatch( setAnswerEditorAction( payload ) ) };
  const recognizeNotes = payload => { dispatch( recognizeNotesAction( payload ) ) };
  const setIsOverStroke = () => {dispatch(setIsOverStrokeAction())};
  const setRemoveStroke = () => {dispatch(setIsOverRemoveStrokeAction())};

  useEffect( () => {
    return () => {
      clearNotepad();
    };
  }, [] );

  useEffect( () => {
    answeringQuestions.data.kypdTyCd && setRecognizeRange( answeringQuestions.data.kypdTyCd );
  }, [ answeringQuestions.data.kypdTyCd ] );

  useEffect( () => {
    if ( answeringQuestions.data.qstCd ) {
      const data = answeringQuestions.data.qstCn.match( /inputArea/gi ) || [];
      setNotepad( { data : data.map( () => '' ) } );
    }
  }, [ answeringQuestions.data.qstCd ] );

  useEffect( () => {
    answeringQuestions.data.qstCd && notepad.canvasDraw.clear && clear();
  }, [ answeringQuestions.data.qstCd, answeringQuestions.answerIndex ] );

  const showClearButton = () => {
    clearTimeout( touchDelayTimer.current );
    setNotepad( { isShowClearButton : true } );
    props.onCount();
  };

  const notes = async ( target ) => {
    await setNotepad({ isEditing: true })
    touchDelayTimer.current = setTimeout( recognize, 0, target );
  };

  const recognize = async ( target ) => {
    if (target.lines.length > 30) {
      setIsOverStroke();
      // clearTimeout(strokeDelayTimer.current);
      // strokeDelayTimer.current = setTimeout(() => {
      //   setRemoveStroke();
      // }, 3000);
      await setNotepad({ isEditing: false })
      return;
    } else {
      const pointsStatus = target.lines.length ? target.lines.some(line => line.points.length > 300) : false;
      if (pointsStatus) {
        setIsOverStroke();
        return;
      }
      await recognizeNotes( { lines : target.lines } );
      await setInputType( TYPE.INPUT.NOTES );
      await setNotepad( { data : notepad.data.map( ( v, i ) => answeringQuestions.answerIndex === i ? target.canvas.drawing.toDataURL() : v ), isOverStroke: false, isOverStrokeDisabled: false, isEditing: false  } );
    }
  };

  const clearAndResetAnswerKey = () => {
    clear();
    setAnswerEditor( { answerKey : '?overwrite' } );
  };

  const clear = () => {
    notepad.canvasDraw.clear();
    setNotepad({ isShowClearButton: false, isErase: false, isOverStroke: false, isOverStrokeDisabled: false } );
  };

  const erase = (bool) => {
    setNotepad({ isErase: bool });
  }

  return cloneElement( props.children || <Fragment />, {
    onShowClearButton : showClearButton,
    onNotes : notes,
    onClear : clearAndResetAnswerKey,
    onErase: erase
  } );

};

export default NoteTaker;
